import api from "../api/api"; // Caminho correto para api.js
const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const aberturaExpedienteService = {
  // ... todos os seus métodos existentes ...

  // NOVOS MÉTODOS PARA FECHAMENTO OUTRO DIA
  
  /**
   * Busca expedientes que ficaram em aberto (sem fechamento)
   * @param {Object} filtros - Filtros para a busca
   * @param {string} filtros.data_inicio - Data de início (YYYY-MM-DD)
   * @param {string} filtros.data_fim - Data de fim (YYYY-MM-DD)
   * @param {number} filtros.id_setor - ID do setor
   * @param {number} filtros.id_funcionario - ID do funcionário
   * @returns {Promise<Object>} Resposta com expedientes em aberto
   */
 // Atualizar os métodos no service

async buscarExpedientesAbertos(filtros = {}) {
  try {
    const params = new URLSearchParams();
    
    if (filtros.data_inicio) params.append('data_inicio', filtros.data_inicio);
    if (filtros.data_fim) params.append('data_fim', filtros.data_fim);
    if (filtros.id_setor) params.append('id_setor', filtros.id_setor);
    if (filtros.id_funcionario) params.append('id_funcionario', filtros.id_funcionario);

    // ✅ URL correta sem barra inicial
    const url = `${BASE_URL}/expediente/em-aberto?${params.toString()}`;
    console.log("🔍 Fazendo requisição para:", url);
    
    const response = await api.get(url);

    if (response.status === 200 && response.data) {
      return {
        success: response.data.success,
        message: response.data.message,
        total: response.data.total,
        dados: response.data.dados,
      };
    } else {
      throw new Error(response.data?.message || "Erro ao buscar expedientes em aberto.");
    }
  } catch (error) {
    console.error("Erro ao buscar expedientes:", error);
    handleError(error, "Erro ao buscar expedientes em aberto.");
    return {
      success: false,
      message: "Erro ao buscar expedientes em aberto.",
      total: 0,
      dados: [],
    };
  }
},

async fechamentoOutroDia(dados) {
  try {
    console.log("📤 Service - Enviando dados:", dados) // Debug
    
    const url = `${BASE_URL}/expediente/fechamento-outro-dia`
    const response = await api.post(url, dados)

    console.log("📥 Service - Resposta recebida:", response.data) // Debug

    if (response.status === 200 && response.data) {
      return {
        success: response.data.success,
        message: response.data.message,
        data_encerramento: response.data.data_encerramento,
        total_alteracoes: response.data.total_alteracoes,
        alteracoes: response.data.alteracoes,
        resumo: response.data.resumo,
      }
    } else {
      throw new Error(response.data?.message || "Erro no fechamento de expediente.")
    }
  } catch (error) {
    console.error("❌ Service - Erro no fechamento:", error)
    console.error("❌ Service - Dados que causaram erro:", dados) // Debug
    
    handleError(error, "Erro no fechamento de expediente.")
    return {
      success: false,
      message: error.response?.data?.message || "Erro no fechamento de expediente.",
      total_alteracoes: 0,
      alteracoes: [],
    }
  }
},
  /**
   * Método auxiliar para formatar data para o backend
   * @param {Date|string} data - Data a ser formatada
   * @returns {string} Data formatada (YYYY-MM-DD HH:mm:ss)
   */
  formatarDataParaBackend(data) {
    if (!data) return null;
    
    const dataObj = typeof data === 'string' ? new Date(data) : data;
    
    if (isNaN(dataObj.getTime())) {
      throw new Error('Data inválida fornecida');
    }
    
    const ano = dataObj.getFullYear();
    const mes = String(dataObj.getMonth() + 1).padStart(2, '0');
    const dia = String(dataObj.getDate()).padStart(2, '0');
    const hora = String(dataObj.getHours()).padStart(2, '0');
    const minuto = String(dataObj.getMinutes()).padStart(2, '0');
    const segundo = String(dataObj.getSeconds()).padStart(2, '0');
    
    return `${ano}-${mes}-${dia} ${hora}:${minuto}:${segundo}`;
  },

  /**
   * Método auxiliar para obter data atual formatada
   * @returns {string} Data atual formatada para input datetime-local
   */
  obterDataAtualParaInput() {
    const agora = new Date();
    const ano = agora.getFullYear();
    const mes = String(agora.getMonth() + 1).padStart(2, '0');
    const dia = String(agora.getDate()).padStart(2, '0');
    const hora = String(agora.getHours()).padStart(2, '0');
    const minuto = String(agora.getMinutes()).padStart(2, '0');
    
    return `${ano}-${mes}-${dia}T${hora}:${minuto}`;
  },

  /**
   * Método auxiliar para obter data de ontem formatada
   * @returns {string} Data de ontem formatada para filtros
   */
  obterDataOntem() {
    const ontem = new Date();
    ontem.setDate(ontem.getDate() - 1);
    
    const ano = ontem.getFullYear();
    const mes = String(ontem.getMonth() + 1).padStart(2, '0');
    const dia = String(ontem.getDate()).padStart(2, '0');
    
    return `${ano}-${mes}-${dia}`;
  },

  // ... resto dos seus métodos existentes ...

  async consultaQuadro(params) {
    try {
      const url = `${BASE_URL}/mudar-calcular-tempo-funcionario`;
      const response = await api.post(url, params);

      if (response.status === 200 && response.data) {
        // Retorna diretamente o status de sucesso e mensagem
        return {
          success: response.data.success,
          message: response.data.message,
          dados: response.data.dados,
        };
      } else {
        throw new Error(response.data?.message || "Erro ao alterar status do expediente.");
      }
    } catch (error) {
      handleError(error, "Erro ao alterar status do expediente.");
      return {
        success: false,
        message: "Erro ao alterar status do expediente.",
      };
    }
  },

  async mudarStatusExpediente(params) {
    try {
      const url = `${BASE_URL}/mudar-status-expediente`;
      const response = await api.post(url, params);

      if (response.status === 200 && response.data) {
        // Retorna diretamente o status de sucesso e mensagem
        return {
          success: response.data.success,
          message: response.data.message,
        };
      } else {
        throw new Error(response.data?.message || "Erro ao alterar status do expediente.");
      }
    } catch (error) {
      handleError(error, "Erro ao alterar status do expediente.");
      return {
        success: false,
        message: "Erro ao alterar status do expediente.",
      };
    }
  },

  // Método para criar uma nova abertura de expediente
  async salvarAbertura(params) {
    try {
      const url = `${BASE_URL}/expediente-salvar`;
      const response = await api.post(url, params);

      if (response.status === 201 && response.data) {
        return response.data;
      } else {
        throw new Error("Erro ao criar abertura de expediente.");
      }
    } catch (error) {
      handleError(error, "Erro ao criar abertura de expediente.");
    }
  },

  // Método para buscar uma abertura específica
  async fetchAberturaPorId(id) {
    try {
      const url = `${BASE_URL}/expedientes/${id}`;
      const response = await api.get(url);

      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        throw new Error("Erro ao obter abertura do expediente.");
      }
    } catch (error) {
      handleError(error, "Erro ao obter abertura do expediente.");
    }
  },

  // Método para atualizar uma abertura de expediente
  async atualizarAbertura(id, params) {
    try {
      const url = `${BASE_URL}/expedientes/${id}`;
      const response = await api.put(url, params);

      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        throw new Error("Erro ao atualizar abertura do expediente.");
      }
    } catch (error) {
      handleError(error, "Erro ao atualizar abertura do expediente.");
    }
  },

  // Método para excluir uma abertura de expediente
  async excluirAbertura(id) {
    try {
      const url = `${BASE_URL}/expedientes/${id}`;
      const response = await api.delete(url);

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Erro ao excluir abertura do expediente.");
      }
    } catch (error) {
      handleError(error, "Erro ao excluir abertura do expediente.");
    }
  },

  // Método para listar movimentações de expediente
  async fetchMovimentacoes(idChefeSetor = null) {
    try {
      let url = `${BASE_URL}/movimentacoes`;

      if (idChefeSetor) {
        url += `/chefe-setor/${idChefeSetor}`;
      }

      const response = await api.get(url);

      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        throw new Error("Erro ao obter movimentações.");
      }
    } catch (error) {
      handleError(error, "Erro ao obter movimentações.");
    }
  },

  // Método para obter setor e sub-setores do chefe
  async obterChefeSetor(idChefe) {
    try {
      const url = `${BASE_URL}/maquinas-setores-chefe/${idChefe}`;
      const response = await api.get(url);
      if (response.status === 200) {
        const data = response.data;

        if (!Array.isArray(data) || data.length === 0) {
          throw new Error("Nenhum setor encontrado para o chefe especificado.");
        }

        // Retorna o primeiro setor (assumindo que a API retorna um array de setores)
        return data[0]; // Contém o setor, sub-setores, e ordens.
      } else {
        throw new Error("Erro ao obter dados do chefe e setor.");
      }
    } catch (error) {
      handleError(error, "Erro ao obter dados do chefe e setor.");
    }
  },

  // Método para criar uma nova movimentação
  async criarMovimentacao(params) {
    try {
      const url = `${BASE_URL}/movimentacoes`;
      const response = await api.post(url, params);

      if (response.status === 201 && response.data) {
        return response.data;
      } else {
        throw new Error("Erro ao criar movimentação.");
      }
    } catch (error) {
      handleError(error, "Erro ao criar movimentação.");
    }
  },

  // Método para excluir uma movimentação
  async excluirMovimentacao(id) {
    try {
      const url = `${BASE_URL}/movimentacoes/${id}`;
      const response = await api.delete(url);

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Erro ao excluir movimentação.");
      }
    } catch (error) {
      handleError(error, "Erro ao excluir movimentação.");
    }
  },

  // Método para listar status do expediente
  async fetchStatus() {
    try {
      const url = `${BASE_URL}/expediente-status`;
      const response = await api.get(url);

      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        throw new Error("Erro ao obter status do expediente.");
      }
    } catch (error) {
      handleError(error, "Erro ao obter status do expediente.");
    }
  },
};

// Função auxiliar para tratar erros
function handleError(error, mensagemPadrao) {
  if (error.response) {
    if (error.response.status === 404) {
      throw new Error("Recurso não encontrado.");
    } else {
      throw new Error(error.response.data.message || mensagemPadrao);
    }
  } else if (error.request) {
    throw new Error("Erro de rede. Por favor, verifique sua conexão.");
  } else {
    throw new Error(error.message || mensagemPadrao);
  }
}